import { render, staticRenderFns } from "./gold-coin-toast.vue?vue&type=template&id=a0ecea04&scoped=true&"
import script from "./gold-coin-toast.vue?vue&type=script&lang=ts&"
export * from "./gold-coin-toast.vue?vue&type=script&lang=ts&"
import style0 from "./gold-coin-toast.vue?vue&type=style&index=0&id=a0ecea04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../home/npm/.npm-global/pnpm-global/5/node_modules/.pnpm/vue-loader@15.9.8_74d29fece135ec2581021cc1bfc8e564/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ecea04",
  null
  
)

export default component.exports